
"use strict";

(function (global) {

  var moreButtonHeaderSelector = ".toolbar-more-button__header";
  var moreButtonContainer = ".toolbar-more-lists";
  var moreButtonSelector = ".toolbar-more-button";

  /**
  * Класс-обертка для панели инструментов.
  * @class WebAccess.components.wrappers.toolBar.ToolBar
  * @since 5.5.0.9000
  */
  var ToolBar = BaseObject.extend({

    init: function (data) {
      var me = this;
      me._super(data);
      me._initButtonMore();
    },

    _initButtonMore: function() {

      var jMoreButtonHeaderSelector = $(moreButtonHeaderSelector);
      var jMoreButtonSelector = $(moreButtonSelector);

      jMoreButtonHeaderSelector.on("click", function () {
        var jActions = $(this).siblings(moreButtonContainer);
        jActions.show();
      });

      var autohide;
      var jActions = jMoreButtonHeaderSelector.siblings(moreButtonContainer);

      // Выравниваем выпадайку по правой границе экрана, если она нвыходит за границы экрана.
      if (jMoreButtonSelector.length > 0 && jActions.width() > $(document).width() - jMoreButtonSelector.offset().left) {
        jActions.addClass('toolbar-more-lists_align-right');
      }

      jMoreButtonSelector
        .off('mouseenter').off('mouseleave')
        .on('mouseenter', function () { if (autohide) clearTimeout(autohide); })
        .on('mouseleave', function () {
          autohide = setTimeout(
                function () {
                   jActions.hide();
                }, 500);
        });
    }
  });

  global.components.wrappers.toolBar.ToolBar = ToolBar;

})(window.WA);
